import { memo, useEffect, useMemo, useState } from "react";
import useValidate from "../../store/hooks/useValidator";
import CreatePage, { CreateModal } from "./CreateUi";
import { useDispatch } from "react-redux";
import { callApiAction } from "../../store/actions/commonAction";

import { closeModal } from "../../store/actions/modalAction";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { GENDER, SNACK_BAR_VARIETNS, USER_ROLES } from "../../utils/constants";
import {
  addBeneficiaryApi,
  getBeneficiaryByIdApi,
  updateBeneficiaryApi,
} from "../../apis/beneficiary.api";
import { callSnackBar } from "../../store/actions/snackbarAction";
import moment from "moment";
import {
  beneficiaryFormData,
  validateEmail,
  validatePhone,
  validateaadhar,
} from "../../utils/helper";
import {
  BENIFICIARY_LOG_STATUS,
  SEVEARITY_OF_LOSS,
  TYPE_OF_HEARING_LOSS,
  WAY_OF_CONFIRMATION,
} from "../../utils/beneficiary.constant";
import { fetchOscillaDetails } from "../../store/actions/OscillaDataAction";

const CreateController = ({ callBack = () => { }, id, role = null, modal }) => {
  const validate = useValidate();
  const dispatch = useDispatch();
  const params = useParams();
  const modalKey = "beneficiary";
  const title = "Beneficiary ";
  const createApi = addBeneficiaryApi;
  const updateApi = updateBeneficiaryApi;
  const getByIdApi = getBeneficiaryByIdApi;

  const [step, setStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const [fetchLoading, setFetchLoading] = useState(false);

  const defaultFields = {
    err: "",
    id,
    first_name: "",
    last_name: "",
    phone: "",
    email: "",
    organization: "",
    department: "",
    designation: "",
    gender: GENDER.MALE,
    dob: moment().toISOString(),
    country: "India",
    state: "",
    district: "",
    taluka: "",
    has_hearing_loss: false,
    address_line: "",
    photo: "",
    PIN: "",
    type_of_hearing_loss: null,
    severity_of_hearing_loss: null,
    left_severity_of_hearing_loss: null,
    right_severity_of_hearing_loss: null,
    audio_gram_file: null,
    nu_device_responce: true,
    music_responce: true,
    voice_responce: true,
    has_smart_phone: true,
    left_response_in_db: 0,
    right_response_in_db: 0,
    left_250: 0,
    left_500: 0,
    left_1000: 0,
    left_2000: 0,
    left_4000: 0,
    left_8000: 0,
    right_250: 0,
    right_500: 0,
    right_1000: 0,
    right_2000: 0,
    right_4000: 0,
    right_8000: 0,
    way_of_confirmation: WAY_OF_CONFIRMATION.VERBAL_CONFIRMATION,
    product: beneficiaryFormData.get("product"),
    camp: beneficiaryFormData.get("camp"),
    suggested_products: beneficiaryFormData.get("suggested_product"),
    dignosis: "",
    right_ear_wax: null,
    right_eardrum: null,
    is_discharge_left: null,
    is_discharge_right: null,
    left_ear_wax: null,
    left_eardrum: null,
  };
  const [fields, setFields] = useState(defaultFields);
  const [originalDocument, setOriginalDocument] = useState({});
const navigate = useNavigate()
  const validationSchemaForCreate = useMemo(
    () => [
      [
        {
          required: true,
          value: fields.camp,
          field: "Camp ",
        },

        {
          required: true,
          value: fields.country,
          field: "Country",
        },
        {
          required: true,
          value: fields.state,
          field: "State",
        },
        {
          required: true,
          value: fields.district,
          field: "District",
        },
        {
          // required: true,
          value: fields.taluka,
          field: "Taluka",
        },
        {
          required: true,
          value: fields.first_name,
          field: "First Name",
        },
        // {
        //   required: true,
        //   value: fields.last_name,
        //   field: "Last Name",
        // },
        {
          required: true,
          value: fields.phone,

          field: "Phone No. ",
          custom: () => {
            if (!validatePhone(fields.phone)) {
              return "Phone No is invalid.";
            }
            return true;
          },
        },
        // {
        //   value: fields.email,
        //   field: "Email",
        //   custom: () => {
        //     if (
        //       // fields.email &&
        //       // fields.email != "" &&
        //       !validateEmail(fields.email)
        //     ) {
        //       return "Email is invalid.";
        //     }
        //     return true;
        //   },
        // },
        {
          required: true,
          value: fields.gender,
          field: "Gender",
        },
        {
          required: true,
          value: fields.dob,
          field: "Date of birth",
        },
        // {
        //   required: true,
        //   value: fields.organization,
        //   field: "Organization",
        // },
        // {
        //   required: true,
        //   value: fields.department,
        //   field: "Department",
        // },
        // {
        //   required: true,
        //   value: fields.designation,
        //   field: "Designation",
        // },

        {
          required: true,
          value: fields.address_line,
          field: "Address ",
        },
        {
          value: fields.PIN,
          field: "PIN ",
          custom: () => {
            if (fields.PIN && fields.PIN != "" && !/^\d{6}$/.test(fields.PIN)) {
              return "Invalid PIN";
            }
            return true;
          },
        },
      ],
    ],
    [fields]
  );

  useEffect(() => {
    beneficiaryFormData.set("camp", fields.camp);
  }, [fields.camp]);
  useEffect(() => {
    beneficiaryFormData.set("product", fields.product);
  }, [fields.product]);
  useEffect(() => {
    beneficiaryFormData.set("country", fields.country);
  }, [fields.country]);

  useEffect(() => {
    beneficiaryFormData.set("state", fields.state);
  }, [fields.state]);
  useEffect(() => {
    beneficiaryFormData.set("district", fields.district);
  }, [fields.district]);
  // useEffect(() => {
  //   beneficiaryFormData.set("taluka", fields.taluka);
  // }, [fields.taluka]);
  useEffect(() => {
    beneficiaryFormData.set("suggested_product", fields.suggested_products);
  }, [fields.suggested_products]);

  const createFunction = async () => {
    const validationResponse = validate(validationSchemaForCreate);

    if (validationResponse === true) {
      const passedData = {};
      const currentFields = { ...fields };
      for (let item in currentFields) {
        passedData[item] =
          currentFields[item] && typeof currentFields[item] == "object"
            ? currentFields[item]["_id"]
            : currentFields[item];
      }

      setLoading(true);
      dispatch(
        callApiAction(
          async () => await createApi(passedData),
          async (response) => {
            await callBack(response);
            setLoading(false);
            setFields({
              ...defaultFields,
              camp: fields.camp,
              country: fields.country,
              state: fields.state,
              district: fields.district,
              // taluka: fields.taluka,
            });
            fetchById(response?._id)
            setStep(1);
            dispatch(
              callSnackBar(
                "Data added successfully",
                SNACK_BAR_VARIETNS.suceess
              )
            );
            dispatch(closeModal(modalKey));
            navigate("/beneficiary/beneficiary-data")
          },
          (err) => {
            setLoading(false);
            setFields({ ...fields, err });
            dispatch(callSnackBar(err, SNACK_BAR_VARIETNS.warning));
          }
        )
      );
      // } else {
      //     setFields({ ...fields, 'err': validationResponse })
      // }
    }
  };
  const updateFunction = async () => {
    let updatedData = { id };

    for (let field in fields) {
      if (fields[field] != originalDocument[field]) {
        const fieldVal = fields[field];
        updatedData[field] =
          fieldVal && typeof fieldVal == "object" ? fieldVal["_id"] : fieldVal;
      }
      if (!originalDocument[field]) {
        const fieldVal = fields[field];
        updatedData[field] =
          fieldVal && typeof fieldVal == "object" ? fieldVal["_id"] : fieldVal;
      }
    }

    // updatedData["status_updated"] = BENIFICIARY_LOG_STATUS.MODIFIED;
    setLoading(true);
    dispatch(
      callApiAction(
        async () => await updateApi({
          ...updatedData,
          id: fields?._id,
        }),
    async (response) => {
      await callBack(response, updatedData);
      setLoading(false);
      dispatch(
        callSnackBar(
          "Data updated successfully",
          SNACK_BAR_VARIETNS.suceess
        )
      );
      dispatch(closeModal(modalKey));
      navigate("/beneficiary/beneficiary-data")
    },
      (err) => {
        setLoading(false);
        setFields({ ...fields, err });
      }
      )
    );
  };

const onSubmit = async (e) => {
  e.preventDefault();
  if (id || (location.pathname.endsWith("/add") && step === 1)) updateFunction();
  else createFunction();
};

const fetchById = (id) => {
  setFetchLoading(true);
  dispatch(
    callApiAction(
      async () => await getByIdApi({ id }),
      async (response) => {
        setFields({ ...fields, ...response });
        setOriginalDocument(response);
        dispatch(fetchOscillaDetails(response?._id));
        setFetchLoading(false);
      },
      (err) => {
        setFields({ ...fields, err });
        setFetchLoading(false);
      }
    )
  );
};

useEffect(() => {
  if (id) fetchById(id);
}, [id]);

{
  console.log("stepsss", step);
}
const onNextButtonClick = (e) => {
  e?.preventDefault();
  const validationResponse = validate(validationSchemaForCreate[step]);
  if (validationResponse === true) { 
    onSubmit(e);
    
    setFields({ ...fields, err: "" });
  } else {
    setFields({ ...fields, err: validationResponse });
    dispatch(callSnackBar(validationResponse, SNACK_BAR_VARIETNS.error));
  }
};

const onPreviosButtonClick = () => {
  if (!loading) {
    if ((id || modal) && step == 0) {
      dispatch(closeModal(modalKey));
    }
    setStep(step - 1 >= 0 ? step - 1 : 0);
  }
};

if (id || modal) {
  return (
    <CreateModal
      fetchLoading={fetchLoading}
      onPreviosButtonClick={onPreviosButtonClick}
      onNextButtonClick={onNextButtonClick}
      step={step}
      modalKey={modalKey}
      title={title}
      isUpdate={id}
      loading={loading}
      fields={fields}
      onSubmit={onSubmit}
      setFields={setFields}
      fetchById={fetchById}
    />
  );
}
return (
  <CreatePage
    fetchLoading={fetchLoading}
    onPreviosButtonClick={onPreviosButtonClick}
    onNextButtonClick={onNextButtonClick}
    step={step}
    setStep={setStep}
    modalKey={modalKey}
    title={title}
    isUpdate={id}
    loading={loading}
    fields={fields}
    onSubmit={onSubmit}
    setFields={setFields}
    fetchById={fetchById}
  />
);
};
export default memo(CreateController);
